import { useState, useEffect } from "react";
import "./ResponseContentPhone.css";
import { Question } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { PhoneResponse } from "../config/responseSettings";
import config from "environment";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { ResponseErrors } from "./responseErrors";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";
import { getCountryCallingCode } from "react-phone-number-input";
// import { FormPhone} from "../form-widgets/FormPhone";

const debugMode = config.debugMode;

type ResponseContentPhoneProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentPhone = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentPhoneProps) => {

    const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [defaultCountryCode, setDefaultCountryCode] = useState<string>("us");
    const [defaultPhoneAsCode, setDefaultPhoneAsCode] = useState<string>("1");
    const [error, setError] = useState<string>("");

    const [country, setCountry] = useState('US')

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setPhone(JSON.parse(responseValues).phone || " ");

        let defaultCountryCode = JSON.parse(question.settings).defaultCountryCode || "us";
        
        let responseCountryCode = JSON.parse(responseValues).countryCode;

        console.log("[ResponseContentPhone] responseValues: ", responseValues);
        console.log("[ResponseContentPhone] defaultCountryCode: ", defaultCountryCode);
        console.log("[ResponseContentPhone] responseCountryCode: ", responseCountryCode);

        const code = responseCountryCode ? responseCountryCode : defaultCountryCode || "us"
        console.log("[ResponseContentPhone] code: ", code);

        setDefaultCountryCode(code.toLowerCase());
        setDefaultPhoneAsCode(getCountryCallingCode((code as string).toUpperCase() as any));

        setError(ResponseErrors.none);
    }, [question, responseValues])

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        console.log("[ResponseContentPhone] handleSubmit: '" + phone + "'");

        if (question.required && phone.trim() === "") {
            setError(ResponseErrors.required);
            return;
        }

        const newResponseValues: string = JSON.stringify({
            phone
        } as PhoneResponse);

        onSubmit(newResponseValues);
    }

    const handleKeyDown = (e: any) => {
        
        if (e.key === "Enter") {
            handleSubmit();
            return;
        }

        setError(ResponseErrors.none);
    }

    const handleChange = (e: any) => {
        setPhone(e.target.value);
    }

    // const handleEnterKeyPress = (e: any) => {
    //     console.log("[ResponseContentPhone] handleSubmit event: ", e);
    // }

    const requirementsMet = !question.required || (phone.trim() !== "");
    
    // console.log("[ResponseContentPhone] question: ", question);
    // console.log("[ResponseContentPhone] values: ", responseValues);
    console.log("[ResponseContentPhone] phone: ", phone);


    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
                        
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div 
                style={{marginTop: "40px"}}
                className="response-content-phone"
                data-testid="response-content-phone"
            >
                {phone && phone.length > 0 &&
                    <PhoneInput
                        country={defaultCountryCode}
                        disableCountryGuess={false}
                        value={phone || defaultPhoneAsCode}
                        enableSearch={true}
                        onChange={phone => setPhone(phone)}
                        onEnterKeyPress={handleSubmit}
                        inputStyle={{
                            backgroundColor: "transparent",
                            width: "250px",
                            color: "var(--ftAnswerColor)",
                            border: "1px solid var(--ftAnswerColor)",
                            fontSize: "1.25rem"
                        }}
                        dropdownStyle={{
                            backgroundColor: "white",
                            border: "1px solid var(--ftAnswerColor)",
                        }}
                        buttonStyle={{
                            backgroundColor: "transparent",
                            border: "1px solid var(--ftAnswerColor)"
                        }}
                        searchStyle={{
                            backgroundColor: "white",
                            border: "1px solid var(--ftAnswerColor)",
                            paddingInline: "0px",
                        }}
                        // containerStyle={{
                        //     backgroundColor: "red",
                        //     // border: "1px solid var(--ftAnswerColor)"
                        // }}
                        inputClass="response-content-phone-input"
                    />
                }
            </div>    
            
            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                allowEnter={true}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}